import { Node } from "../nodes/node"
import { ConditionRenderer } from "../nodes/renderers/condition"
import { EventRenderer } from "../nodes/renderers/event"
import { ActionRenderer } from "../nodes/renderers/action"
import { EndRenderer } from "../nodes/renderers/end"
import escape from "lodash/escape"

export class PreviewNode extends Node {
  static get elementName() {
    return "workflow-preview-node"
  }

  initialize(roots, data) {
    this.compute(roots, data)
    switch (this.dataset.kind) {
      case "condition":
        this.renderer = new ConditionRenderer(this)
        break
      case "event":
        this.renderer = new EventRenderer(this)
        break
      case "action":
        this.renderer = new ActionRenderer(this)
        break
      case "end":
        this.renderer = new EndRenderer(this)
        break
    }

    this.renderer.render()
  }

  attributeChangedCallback(attributeName) {
    if (attributeName == "data-name" || attributeName == "data-detail") {
      if (this.detail && this.detail != "null") {
        if (this.detail.icon_url && !this.detail.app_removed) {
          fetch(this.detail.icon_url).then(response => {
            response.blob().then(blob => {
              if (blob.type == "image/svg+xml") {
                this.find(".workflow-node .badge").innerHTML =
                  `<div class="bg-white w-full h-full" style="mask: url(${escape(
                    this.renderer.detail.icon_url
                  )}) no-repeat center;"></div>`
              } else {
                this.find(".workflow-node .badge").innerHTML =
                  `<img src="${escape(this.detail.icon_url)}" alt="" />`
              }
            })
          })
        }
      }
    }
  }

  bindEdit() {}

  // Hijacking this method to render explanations in the stats box
  renderStats() {
    const parent = this.parentNode
    if (!parent || !parent.new_template_preview?.()) return

    this.classList.add("new-template-preview")

    const notes = parent.notes?.() || []

    const { body: noteText } =
      notes.find(({ step_id, step_type }) => {
        return step_type == this.dataset.type && step_id == this.dataset.typeId
      }) || {}

    if (noteText) {
      const explanation =
        this.find(".workflow-stats") ||
        this.find(".workflow-node").appendChild(document.createElement("div"))
      explanation.classList.add("workflow-stats", "workflow-stats__stat")
      explanation.innerText = noteText
    }
  }

  renderButtons() {}
}

customElements.get("workflow-preview-node") ||
  customElements.define("workflow-preview-node", PreviewNode)
